import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Edition } from '../models/edition.model';

@Injectable({
    providedIn: 'root'
})
export class EditionService {

    private readonly apiURL: string;

    constructor(private readonly http: HttpClient, private readonly appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/edition';

    }

    public get(): any {

        const url = this.apiURL;
        return this.http.get<Edition[]>(url);

    }

    public getById(editionId: number) {

        const url = `${this.apiURL}/${editionId}`;
        return this.http.get<Edition[]>(url);

    }

}
